import { render, staticRenderFns } from "./MortgageApplicationDrawdownPopup.vue?vue&type=template&id=ad996506&scoped=true&"
import script from "./MortgageApplicationDrawdownPopup.vue?vue&type=script&lang=js&"
export * from "./MortgageApplicationDrawdownPopup.vue?vue&type=script&lang=js&"
import style0 from "./MortgageApplicationDrawdownPopup.vue?vue&type=style&index=0&id=ad996506&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad996506",
  null
  
)

export default component.exports